import { render, staticRenderFns } from "./DialogListComission.vue?vue&type=template&id=a705be06&scoped=true"
import script from "./DialogListComission.vue?vue&type=script&lang=js"
export * from "./DialogListComission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a705be06",
  null
  
)

export default component.exports